// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".type-select{margin-left:1.5rem}.type-select__option{border:none;background:none;font-size:1.3rem;font-weight:600;color:#6C7A9F}.type-select__option--selected{color:#3383E1}\n", ""]);
// Exports
module.exports = exports;
